import { useParams } from 'react-router-dom';
import '../../index.css';
import CardBlockView from '@/components/bodyBlocks/cardsBlock/cardsBlock';

const Profesiones = () => {
  const { seccion } = useParams<{ seccion?: string }>();

  return (
/*     <div style={{ marginTop: '80px' }}> */
      <CardBlockView seccion={seccion} />
    /* </div> */
  );
};

export default Profesiones;
